import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=00b51dc0&scoped=true&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"
import style0 from "./Tab.vue?vue&type=style&index=0&id=00b51dc0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b51dc0",
  null
  
)

export default component.exports